
<template>
  <div :style="{ margin: '2rem' }">
    <dialog-loading
      :message="loadingMessage"
      :active="loading"
    />
    <!-- <confirmation-modal
      :active="abatementModal"
      :handleConfirm="requestAbatement"
      :handleCancel="hideModalAbatement"
      title="Solicitação de abatimento"
      message="Você tem certeza que deseja solicitar o abatimento?"
    /> -->
    <confirmation-modal
      :active="confirmModal"
      :handleConfirm="handleAcceptConfirmModal"
      :handleCancel="handleCancelConfirmModal"
      title="Remover reserva"
      message="Você tem certeza que deseja deletar esta reserva?"
    />
    <v-card>
      <v-data-table
        :headers="headers"
        :items="reserves"
        :options.sync="options"
        :server-items-length="total"
        :disable-sort="true"
        :loading="loading"
        loading-text="Carregando... Por favor, aguarde"
        no-data-text="Nenhuma reserva encontrada"
        :footer-props=" {
          showFirstLastPage: true,
          'items-per-page-text': 'registros por página',
          'items-per-page-options': optionsPage,
          pageText: '{0}-{1} de {2}'
        }"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="title-bold">Solicitação de reserva</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="isAdmin" color="green" dark class="mb-2" v-on:click="exportExcel">
              Exportar
            </v-btn>
            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="!isAdmin"
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Nova reserva
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-select
                            :items="properties"
                            no-data-text="Sem dados"
                            item-text="name"
                            item-value="id"
                            label="Empreendimento"
                            :rules="requiredRule"
                            v-model="reserve.property"
                            required
                            disabled
                          />
                          <!-- :disabled="!modeCreate" -->
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-select
                            :items="brokerItems"
                            item-text="name"
                            item-value="id"
                            label="Corretor"
                            no-data-text="Sem dados"
                            :rules="requiredRule"
                            v-model="reserve.broker"
                            :disabled="isDisabledBroker"
                            required
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-mask="maskClient()"
                            v-model="reserve.identifierClient"
                            :rules="requiredRule"
                            label="CPF/CNPJ Cliente"
                            required
                            :disabled="!modeCreate"
                            @blur="getClientByCpfCnpj"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="reserve.client.name"
                            label="Nome"
                            :rules="requiredRule"
                            required
                            disabled
                          />
                        </v-col>
												<!-- <v-col cols="12" sm="6" md="4">
                          <v-select
                            :items="typeAtendances"
                            no-data-text="Sem dados"
                            item-text="name"
                            item-value="id"
                            label="Tipo de Atendimento"
                            :rules="requiredRule"
                            v-model="reserve.typeAtendance"
                            required
                          />
                        </v-col> -->
                        <v-col cols="12" sm="6" md="6">
                          <v-select
                            :items="typeBuys"
                            item-text="name"
                            item-value="id"
                            label="Tipo de Compra"
                            no-data-text="Sem dados"
                            :rules="requiredRule"
                            v-model="reserve.typeBuy"
                            required
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-select
                            :items="conditionPayments"
                            item-text="name"
                            item-value="id"
                            label="Pretensão de Pagamento"
                            :rules="requiredRule"
                            no-data-text="Sem dados"
                            v-model="reserve.conditionPayment"
                            required
                          />
                        </v-col>

                        <!-- <v-col cols="12" sm="6" md="6">
                         <v-select
                            :items="numberLots"
                            item-text="name"
                            item-value="id"
                            label="Número de Lotes"
                            no-data-text="Sem dados"
                            :rules="requiredRule"
                            v-model="reserve.numberLot"
                            required
                          />
                        </v-col> -->

                        <v-col cols="12" sm="6" md="6">
                         <v-select
                            :items="sizeApartments"
                            item-text="name"
                            item-value="id"
                            label="Tamanho da Sala"
                            no-data-text="Sem dados"
                            :rules="requiredRule"
                            v-model="reserve.sizeApartment"
                            required
                          />
                        </v-col>
                        <!-- <v-col v-if="!!reserve.numberLot" cols="12" sm="6" md="4">
                          <v-select
                            :items="sizeLots"
                            item-text="name"
                            item-value="id"
                            label="Primeiro Lote"
                            no-data-text="Sem dados"
                            v-model="reserve.firstLot"
                            :rules="requiredRule"
                            required
                            />
                        </v-col>
                        <v-col v-if="quantLots > 1" cols="12" sm="6" md="4">
                          <v-select
                            :items="sizeLots"
                            item-text="name"
                            item-value="id"
                            label="Segundo Lote"
                            no-data-text="Sem dados"
                            v-model="reserve.secondLot"
                            :rules="requiredRule"
                            required
                            />
                        </v-col>
                        <v-col v-if="quantLots > 2" cols="12" sm="6" md="4">
                          <v-select
                            :items="sizeLots"
                            item-text="name"
                            item-value="id"
                            label="Terceiro Lote"
                            no-data-text="Sem dados"
                            v-model="reserve.thirdLot"
                            :rules="requiredRule"
                            required
                            />
                        </v-col>
                        <v-col v-if="quantLots > 3" cols="12" sm="6" md="4">
                          <v-select
                            :items="sizeLots"
                            item-text="name"
                            item-value="id"
                            label="Quarto Lote"
                            no-data-text="Sem dados"
                            v-model="reserve.fourthLot"
                            :rules="requiredRule"
                            required
                            />
                        </v-col>
                        <v-col v-if="quantLots > 4" cols="12" sm="6" md="4">
                          <v-select
                            :items="sizeLots"
                            item-text="name"
                            item-value="id"
                            label="Quinto Lote"
                            no-data-text="Sem dados"
                            v-model="reserve.fifthLot"
                            :rules="requiredRule"
                            required
                          />
                        </v-col> -->

                        <!-- <v-col cols="12" sm="6" md="6">
                          <v-switch
                            v-model="reserve.buildInTwoYears"
                            inset
                            label="Pretende construir em até 2 anos após a entrega do lote?"
                          ></v-switch>
                          <v-select
                            :items="buildInTwoYearsItems"
                            item-text="label"
                            item-value="value"
                            label="Pretende construir em até 2 anos após a entrega do lote?"
                            no-data-text="Sem dados"
                            v-model="reserve.buildInTwoYears"
                            :rules="requiredBooleanRule"
                            required
                          />
                        </v-col> -->

                        <!-- <v-col cols="12" sm="6" md="6">
                          <v-select
                            :items="parkingSpaceItems"
                            item-text="label"
                            item-value="value"
                            label="Vaga de garagem?"
                            no-data-text="Sem dados"
                            v-model="reserve.parkingSpace"
                            :rules="requiredBooleanRule"
                            required
                          />
                        </v-col> -->

                        <!-- Apenas para adicionar o comprovante na criação da reserva -->
                        <v-col v-if="modeCreate" cols="12" sm="6" md="6">
                          <v-file-input
                            v-if="isGoldAttendance"
                            v-model="reserve.document"
                            label="Comprovante de pagamento"
                            placeholder="Tipos permitidos: .png .jpg .jpeg e .pdf"
                            accept="image/png,image/jpeg,image/heic,image/heif,application/pdf"
                            required
                            multiple
                            small-chips
                            :rules="fileRules"
                          ></v-file-input>
                        </v-col>
                        <v-col v-for="(doc, index) in reserve.documents" :key="doc.id" cols="12" sm="6" md="6">
                          <v-file-input
                            :clearable="false"
                            v-if="isGoldAttendance"
                            v-model="reserve.documents[index]"
                            label="Comprovante de pagamento"
                            placeholder="Tipos permitidos: .png .jpg .jpeg e .pdf"
                            accept="image/png,image/jpeg,image/heic,image/heif,application/pdf"
                            required
                            small-chips
                            :rules="fileRules"
                          ></v-file-input>
                        </v-col>
                         <!-- Apenas na edição da reserva para add um novo comprovante -->
                        <v-col v-if="!modeCreate && reserve.numberLot > actualNumberLot" cols="12" sm="6" md="6">
                          <v-file-input
                            v-if="isGoldAttendance"
                            v-model="reserve.newDocument"
                            label="Novo Comprovante de pagamento"
                            placeholder="Tipos permitidos: .png .jpg .jpeg e .pdf"
                            accept="image/png,image/jpeg,image/heic,image/heif,application/pdf"
                            required
                            multiple
                            :rules="fileRules"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue" :disabled="!valid" text @click="validate">Salvar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>

          <v-container>
            <v-row>
              <!--<v-col cols="12" sm="4" md="3">
                <v-select
                  :items="typeAtendances"
                  item-text="name"
                  item-value="id"
                  no-data-text="Sem dados"
                  label="Tipo de atendimento"
                  v-model="filters.typeAtendance"
                />
              </v-col> -->
              <v-col cols="12" sm="4" md="3">
                <v-select
                  :items="statusesItems"
                  item-text="name"
                  item-value="id"
                  no-data-text="Sem dados"
                  label="Status"
                  v-model="filters.status"
                />
              </v-col>
              <v-col v-if="isAdmin" cols="12" sm="4" md="3">
                <v-select
                  :items="propertyItems"
                  item-text="name"
                  item-value="id"
                  no-data-text="Sem dados"
                  label="Empreendimento"
                  v-model="filters.property"
                />
              </v-col>
              <v-col v-if="isAdmin" cols="12" sm="4" md="3">
                <v-select
                  :items="realStateItems"
                  item-text="name"
                  item-value="id"
                  no-data-text="Sem dados"
                  label="Imobiliária"
                  v-model="filters.realState"
                />
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-text-field
                  label="Nome"
                  v-model="filters.name"
                />
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-select
                  :items="paymentStatusesItems"
                  item-text="name"
                  item-value="id"
                  no-data-text="Sem dados"
                  label="Status Financeiro"
                  v-model="filters.paymentStatus"
                />
              </v-col>
              <v-col cols="12" sm="4" md="1">
                <v-btn color="green" class="btn-filter" text @click="filterReserves">Buscar</v-btn>
              </v-col>
              <v-col cols="12" sm="4" md="1">
                <v-btn color="red" class="btn-filter" text @click="clearFilters">Limpar Filtros</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <div v-if="item.client.is_active">
            {{ item.client.name }}
          </div>
          <div v-else>
            {{ item.client.name }} (DELETADO)
          </div>
        </template>
        <template v-slot:[`item.receipt`]="{ item }">
          <div v-if="item.documents.length > 0">
            <v-icon
              small
              class="mr-2"
              :color="item.status.id === 1 ? 'gray' : item.status.id === 2 ? 'green' : 'red'"
              :disabled="item.documents.length === 0 ? true : false"
              @click="openDocuments(item.documents)"
            >
              mdi-account-box
            </v-icon>
            <v-icon
              v-if="isAdmin && [1, 3].includes(item.status.id)"
              small
              class="mr-2"
              color="green"
              @click="acceptDoc(item)"
            >
              mdi-spellcheck
            </v-icon>
            <v-icon
              v-if="isAdmin && [1, 2].includes(item.status.id)"
              small
              color="red"
              @click="openRejectModal(item)"
            >
              mdi-close
            </v-icon>
          </div>
        </template>
        <template v-slot:[`item.payment`]="{ item }">

          {{ item.paymentStatus.name}}

          <v-btn
            v-if="item.paymentStatus.id == 1 && isAdmin"
            x-small
            color="primary"
            class="ma-1 white--text"
            @click="alterStatusPayment(item, 2)"
          >
            Pago
          </v-btn>
          <!-- <v-btn
            v-if="item.paymentStatus.id == 2 && !isAdmin"
            x-small
            color="primary"
            class="ma-1 white--text"
            @click="openDevolutionModal(item)"
          >
            Solicitar Devolução
          </v-btn> -->
          <!-- <v-btn
            v-if="item.paymentStatus.id == 2 && !isAdmin"
            x-small
            color="primary"
            class="ma-1 white--text"
            @click="openAbatementModal(item)"
          >
            Solicitar Abatimento
          </v-btn> -->
          <v-icon
            v-if="item.paymentStatus.id == 3 && isAdmin"
            small
            class="mr-2"
            @click="showDevolution(item.id)"
          >
            mdi-account-alert
          </v-icon>
          <!-- <v-btn
            v-if="item.paymentStatus.id == 3 && isAdmin"
            x-small
            color="primary"
            class="ma-1 white--text"
            @click="alterStatusPayment(item, 6)"
          >
            Devolução Realizada
          </v-btn>
          <v-btn
            v-if="item.paymentStatus.id == 4 && isAdmin"
            x-small
            color="primary"
            class="ma-1 white--text"
            @click="alterStatusPayment(item, 5)"
          >
            Abatimento Realizado
          </v-btn> -->
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="edit(item)"
          >
            mdi-circle-edit-outline
          </v-icon>
          <v-icon
            small
            @click="openConfirmModal(item)"
          >
            mdi-delete-empty
          </v-icon>
        </template>
        <template v-slot:no-data>
          Sem dados
        </template>
      </v-data-table>
    </v-card>
    <reject-modal @alter-status="alterStatus" :emailMessageReject.sync="emailMessageReject" :showModalReject.sync="showModalReject"/>
    <devolution-modal @save-devolution="saveDevolution" :showConfirmation.sync="confirmModalDevolution" :reserve.sync="item" :devolution.sync="devolution" :viewDevolutionData.sync="viewDevolutionData" :showModalDevolution.sync="showModalDevolution"/>
  </div>
</template>

<script>
import DialogLoading from '@/components/loading/DialogLoading'
import RejectModal from '@/components/modals/RejectModal'
import ConfirmationModal from '@/components/modals/ConfirmationModal'
import DevolutionModal from '@/components/modals/DevolutionModal'
import message from '@/utils/message'
import { normalizeFiles, isAllowedFile } from '@/utils/imageFile'
import xlsx from 'json-as-xlsx'
import api from '@/services/api'
import store from '@/store'

export default {
  components: {
    DialogLoading,
    ConfirmationModal,
    DevolutionModal,
    RejectModal
  },

  data: () => ({
    total: 0,
    options: {
      page: 1,
      itemsPerPage: 10
    },
    optionsPage: [10, 25, 50, 100],
    numberLots: [
      { id: 1, name: 'Um' },
      { id: 2, name: 'Dois' }
      // { id: 3, name: 'Três' },
      // { id: 4, name: 'Quatro' },
      // { id: 5, name: 'Cinco' }
    ],
    confirmModal: false,
    confirmModalDevolution: false,
    hasSure: false,
    itemToDelete: null,
    dialog: false,
    loading: true,
    loadingMessage: 'Carregando',
    valid: true,
    requiredRule: [
      v => !!v || 'Informação obrigatória'
    ],
    requiredBooleanRule: [
      v => typeof v === 'boolean' || 'Informação obrigatória'
    ],
    fileRules: [
      v => {
        if (Array.isArray(v)) {
          if (v.length === 0) {
            return 'Informação obrigatória'
          }
        } else if (!v) {
          return 'Informação obrigatória'
        }
        return true
      },
      v => {
        let messages = []
        if (Array.isArray(v)) {
          v.forEach(file => {
            if (file && !isAllowedFile(file)) {
              messages.push('Tipos permitidos: .png .jpg .jpeg e .pdf')
            }
            if (file && (file.size >= 5242880)) {
              messages.push('Tamanho máximo de arquivo 5MB')
            }
          })
          return messages.length === 0 || messages.join(', ')
        } else if (v) {
          if (typeof v.id === 'undefined') {
            messages.push('Tamanho máximo de arquivo 5MB')
          }
          return messages.length === 0 || messages.join(', ')
        }
        return true
      }
    ],
    headers: [
      { text: 'Cliente', align: 'start', value: 'name' },
      { text: 'Corretor', value: 'broker.name' },
      // { text: 'Quantidade de lotes', value: 'numberLot.name' },
      { text: 'Comprovante', value: 'receipt' },
      { text: 'Pagamento', value: 'payment' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    properties: [],
    propertyItems: [],
    realStateItems: [],
    brokerItems: [],
    statusesItems: [],
    paymentStatusesItems: [],
    reserves: [],
    typeAtendances: [],
    sizeLots: [],
    typeBuys: [],
    conditionPayments: [],
    buildInTwoYearsItems: [
      { value: true, label: 'Sim' },
      { value: false, label: 'Não' }
    ],
    sizeApartments: [],
    parkingSpaceItems: [
      { value: true, label: 'Sim' },
      { value: false, label: 'Não' }
    ],
    editedIndex: -1,
    editedId: false,
    actualNumberLot: null,
    showNewDocument: false,
    brokerLogged: store.getters.user.broker,
    historyDocs: [],
    reserve: {
      id: null,
      property: 2,
      client: { id: null, name: null },
      broker: null,
      typeAtendance: 1,
      numberLot: null,
      typeBuy: null,
      conditionPayment: null,
      identifierClient: null,
      documents: [],
      document: null,
      newDocument: null,
      status: { id: 1 },
      firstLot: null,
      secondLot: null,
      thirdLot: null,
      fourthLot: null,
      fifthLot: null,
      buildInTwoYears: null,
      sizeApartment: null,
      parkingSpace: null
    },
    defaultItem: {
      id: null,
      property: 2,
      brokerName: null,
      client: { id: null, name: null },
      broker: null,
      typeAtendance: 1,
      numberLot: null,
      typeBuy: null,
      conditionPayment: null,
      identifierClient: null,
      documents: [],
      document: null,
      newDocument: null,
      status: { id: 1 },
      firstLot: null,
      secondLot: null,
      thirdLot: null,
      fourthLot: null,
      fifthLot: null,
      buildInTwoYears: null,
      sizeApartment: null,
      parkingSpace: null
    },
    filters: {
      typeAtendance: null,
      status: null,
      property: null,
      realState: null,
      name: null,
      paymentStatus: null
    },
    showModalReject: false,
    viewDevolutionData: false,
    emailMessageReject: null,
    item: null,
    showModalDevolution: false,
    abatementModal: false,
    devolution: {
      name: null,
      cpf: null,
      cnpj: null,
      code_bank: undefined,
      name_bank: null,
      ag: null,
      type_account: null,
      account: null,
      pix_key_id: null,
      pix_key_name: null,
      pix_value: null
    }
  }),

  computed: {
    quantLots () {
      if (this.reserve.numberLot) {
        return this.reserve.numberLot.id ? this.reserve.numberLot.id : this.reserve.numberLot
      }
      return this.reserve.numberLot
    },

    formTitle () {
      return this.editedIndex === -1 ? 'Nova reserva' : 'Editar reserva'
    },

    modeCreate () {
      return this.editedIndex === -1
    },

    isAdmin () {
      return store.getters.user.userType !== null && store.getters.user.userType.id === 1
    },

    isManager () {
      return store.getters.user.userType !== null && store.getters.user.userType.id === 3
    },

    isDisabledBroker () {
      if (this.isAdmin) return false
      // else if (this.isManager && this.modeCreate) return false
      return true
    },

    isGoldAttendance () {
      return this.reserve.typeAtendance === 1 || (this.reserve.typeAtendance && this.reserve.typeAtendance.id === 1)
    }
  },

  watch: {
    options: {
      handler () {
        this.getReserves()
      },
      deep: true
    },

    dialog (val) {
      val || this.close()
    },

    // 'reserve.property' (newValue, _oldValue) {
    //   if (newValue) {
    //     this.getSizeLots(newValue.id ? newValue.id : newValue)
    //   }
    // },

    // 'reserve.numberLot' (newValue, _oldValue) {
    //   if (this.actualNumberLot > newValue && !this.modeCreate && !this.isAdmin) {
    //     message.error('Para diminuir a quantidade, favor tratar com o gerente comercial da Idealiza')
    //     this.reserve.numberLot = this.actualNumberLot
    //   }
    // },

    'reserve.documents' (newDocs, _oldDocs) {
      if (newDocs.length > 0) {
        newDocs.forEach(async (doc, index) => {
          if (!doc.id) {
            this.reserve.documents[index] = await this.updateDocument(doc, this.historyDocs[index].id)
          }
        })
      }
    }
  },

  created () {
    this.getProperties()
    this.getPaymentStatuses()
    this.getRealEstates()
    this.getPropertiesFromRealState()
    this.getBrokers()
    this.getStatuses()
    this.getTypeBuys()
    this.getConditionPayments()
    // this.getTypeAtendances()
    // this.getSizeLots(1)
    // this.getNumberLots()
    this.getSizeApartments()

    if (!this.isAdmin && !this.isManager) {
      this.reserve.broker = store.getters.user.broker
    }
  },

  methods: {
    async requestAbatement () {
      this.alterStatusPayment(this.item, 4)
      this.hideModalAbatement()
    },

    async getRealEstates () {
      try {
        const { data } = await api.get('/real-states?page=-1&itemsPerPage=-1')
        this.realStateItems = data.data
      } catch (error) {
        message.error('Erro ao buscar imobiliárias')
      }
    },

    async getPaymentStatuses () {
      try {
        const { data } = await api.get('/payment-statuses')
        this.paymentStatusesItems = data
      } catch (error) {
        message.error('Erro ao buscar os status de pagamento')
      }
    },

    async alterStatusPayment (item, status) {
      this.loading = true
      try {
        const { data } = await api.put(`reserves/${item.id}/payment-status`, { payment_status_id: status })
        item.paymentStatus.id = data.id
        item.paymentStatus.name = data.name

        message.success('Status alterado')
      } catch (error) {
        message.error(error.message)
      } finally {
        this.loading = false
      }
    },

    async openDevolutionModal (item) {
      this.showModalDevolution = true
      this.item = item
    },

    async openAbatementModal (item) {
      this.abatementModal = true
      this.item = item
    },

    hideModalAbatement () {
      this.abatementModal = false
    },

    async showDevolution (reserveId) {
      this.showModalDevolution = true
      this.viewDevolutionData = true
      const { data } = await api.get(`reserves/${reserveId}/devolutions`)
      this.devolution = data
    },

    async saveDevolution () {
      try {
        const devolution = this.devolution
        devolution.reserve_id = this.item.id
        devolution.client_name = this.item.client.name

        const { data } = await api.post('reserves/devolution', devolution)
        if (data.id) {
          this.alterStatusPayment(this.item, 3)
        }
      } catch (error) {
        message.error(error.message)
      } finally {
        this.showModalDevolution = false
        this.item = null
        this.devolution.name = null
        this.devolution.cpf = null
        this.devolution.cnpj = null
        this.devolution.code_bank = null
        this.devolution.name_bank = null
        this.devolution.ag = null
        this.devolution.type_account = null
        this.devolution.account = null
        this.devolution.pix_key_id = null
        this.devolution.pix_key_name = null
        this.devolution.pix_value = null
      }
    },

    maskClient () {
      if (!this.modeCreate || !this.reserve.identifierClient) {
        return ''
      }

      return this.reserve.identifierClient && this.reserve.identifierClient.length > 14 ? '##.###.###/####-##' : '###.###.###-##'
    },
    async exportExcel () {
      try {
        const { data } = await api.get('/reserves?page=-1&itemsPerPage=-1')

        const dataExcel = [
          {
            sheet: 'Lista',
            columns: [
              { label: 'Nome', value: row => row.client.name },
              { label: 'CPF', value: row => row.client.cpf },
              { label: 'CNPJ', value: row => row.client.cnpj },
              { label: 'Empreendimento', value: row => row.property.name },
              { label: 'Corretor', value: row => row.broker.name },
              { label: 'Imobiliária', value: row => row.broker.realState.name },
              { label: 'Tipo de Atendimento', value: row => row.typeAtendance ? row.typeAtendance.name : '' },
              // { label: 'Tamanho do Lote', value: row => row.sizeLot ? row.sizeLot.name : '' },
              { label: 'Tipo de Compra', value: row => row.typeBuy ? row.typeBuy.name : '' },
              { label: 'Condição de pagamento', value: row => row.conditionPayment ? row.conditionPayment.name : '' },
              { label: 'Situação', value: row => row.status ? row.status.name : '' },
              { label: 'Tamanho de Apartamento', value: row => row.sizeApartment ? row.sizeApartment.name : '' },
              // { label: 'Vaga de Garagem', value: row => row.parkingSpace !== null ? (row.parkingSpace ? 'Sim' : 'Não') : 'Não' },
              { label: 'Quantidade de Lotes', value: row => row.numberLot.id },
              { label: 'Primeiro Lote', value: row => row.firstLot ? row.firstLot.name : '' },
              { label: 'Segundo Lote', value: row => row.secondLot ? row.secondLot.name : '' },
              // { label: 'Terceiro Lote', value: row => row.thirdLot ? row.thirdLot.name : '' },
              // { label: 'Quarto Lote', value: row => row.fourthLot ? row.fourthLot.name : '' },
              // { label: 'Quinto Lote', value: row => row.fifthLot ? row.fifthLot.name : '' },
              { label: 'Data de Criação', value: row => row.created_at ? row.created_at : '' }
            ],
            content: data.data
          }
        ]

        const settings = {
          fileName: 'Reservas',
          extraLength: 3,
          writeOptions: {}
        }

        xlsx(dataExcel, settings)
      } catch (error) {
        message.error(error.message)
      }
    },

    async getStatuses () {
      try {
        const { data } = await api.get('/statuses')
        this.statusesItems = data
      } catch (error) {
        message.error('Erro ao buscar status')
      } finally {
        this.loading = false
      }
    },

    async viewDoc (item) {
      try {
        const listIds = item.documents.map(doc => doc.id)

        listIds.forEach(async id => {
          const { data } = await api.get(`/documents/${id}`)

          if (data.type === 'image') {
            return this.openImage(data.base64)
          }

          this.openPdf(data.base64)
        })
      } catch (error) {
        message.error(error.message)
      }
    },

    async openDocuments (documents) {
      try {
        this.loading = true
        this.loadingMessage = 'Carregando'

        const files = []

        for (const doc of documents) {
          const { data } = await api.get(`/documents/${doc.id}`)

          if (data.type === 'image') {
            const image = new Image()
            image.src = 'data:image/png;base64,' + data.base64
            image.style.maxWidth = '100%'

            files.push(image.outerHTML, '<br>')
          } else {
            const blob = this.base64ToBlob(data.base64, 'application/pdf')
            const url = URL.createObjectURL(blob)
            files.push("<iframe width='100%' height='100%' style='border: none; margin-bottom: 24px;' src='" + url + "'></iframe>")
          }
        }

        const w = window.open('', '_blank')
        w.document.write(...files)
      } catch (_error) {
        message.error('Erro ao carregar documentos')
      } finally {
        this.loading = false
      }
    },

    async acceptDoc (item) {
      this.loading = true
      try {
        await api.put(`reserves/${item.id}/status`, { status_id: 2 })
        item.colorStatus = 'green'
        item.status.id = 2
        message.success('Status atualizado')
      } catch (error) {
        message.error(error.message)
      } finally {
        this.loading = false
      }
    },

    async openRejectModal (item) {
      this.showModalReject = true
      this.item = item
    },

    async alterStatus () {
      this.showModalReject = false
      if (!this.emailMessageReject) {
        this.resetEmailsInfos()
        return message.error('Motivo: Mensagem do e-mail vazia', 'Status não atualizado')
      }
      this.rejectDoc()
    },

    async resetEmailsInfos () {
      this.emailMessageReject = null
      this.item = null
    },

    async rejectDoc () {
      try {
        this.loading = true
        await api.put(`reserves/${this.item.id}/status`, { status_id: 3, emailMessage: this.emailMessageReject })
        this.item.colorStatus = 'red'
        this.item.status.id = 3
        message.success('Status atualizado')
      } catch (error) {
        message.error(error.message)
      } finally {
        this.resetEmailsInfos()
        this.loading = false
      }
    },

    openImage (base64) {
      const image = new Image()
      image.src = 'data:image/png;base64,' + base64
      image.style.maxWidth = '100%'
      const w = window.open('')
      w.document.write(image.outerHTML)
    },

    openPdf (base64) {
      const blob = this.base64ToBlob(base64, 'application/pdf')
      const url = URL.createObjectURL(blob)
      const pdfWindow = window.open('')
      pdfWindow.document.write("<iframe width='100%' height='100%' src='" + url + "'></iframe>")
    },

    base64ToBlob (base64, type = 'application/octet-stream') {
      const binStr = atob(base64)
      const len = binStr.length
      const arr = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        arr[ i ] = binStr.charCodeAt(i)
      }
      return new Blob([ arr ], { type: type })
    },

    async getClientByCpfCnpj () {
      try {
        if (this.reserve.identifierClient && (this.reserve.identifierClient.length === 14 || this.reserve.identifierClient.length === 18)) {
          const response = await api.get(`/clients/info?clientIdentifier=${this.reserve.identifierClient}`)

          if (response.data) {
            const { data } = await api.post('/reserves/validate', {clientIdentifier: this.reserve.identifierClient})
            if (!data) {
              message.error('Cliente já possui reserva ativa nessa imobiliária!')
              this.reserve.identifierClient = null
              this.reserve.client.id = null
              this.reserve.client.name = null
              return
            }

            this.reserve.client = {
              id: response.data.id,
              name: response.data.name
            }
            if (this.isAdmin || this.isManager) {
              this.reserve.broker = response.data.broker
            }

            // /*let routeData = this.$router.resolve({path: `/clientes/${response.data.id}/editar`, query: { by: 'reserva' }})
            // /*return window.open(routeData.href, '_blank')
          } else {
            message.error('Nenhum cliente ativo vinculado a imobiliária com este CPF/CNPJ')
            this.reserve.identifierClient = null
            this.reserve.client.id = null
            this.reserve.client.name = null
          }
        }
      } catch (error) {
        message.error(error.message)
      } finally {
        this.loading = false
      }
    },

    async getPropertiesFromRealState () {
      try {
        const { data } = await api.get('/real-states?page=-1&itemsPerPage=-1')

        if (data.data && data.data.length > 0) {
          this.properties = data.data[0].properties
          // Adicionado para pegar apenas o primeiro empreendimento sempre
          this.reserve.property = this.properties[0]
        }
      } catch (error) {
        message.error('Erro ao buscar empreendimentos')
      } finally {
        this.loading = false
      }
    },

    async getProperties () {
      try {
        const { data } = await api.get('/properties')
        this.propertyItems = data
      } catch (error) {
        message.error('Erro ao buscar empreendimentos')
      } finally {
        this.loading = false
      }
    },

    async getReserves () {
      try {
        this.loading = true

        const { data } = await api.get(`/reserves?page=${this.options.page}&itemsPerPage=${this.options.itemsPerPage}&typeAtendance=${this.filters.typeAtendance}&status=${this.filters.status}&property=${this.filters.property}&realState=${this.filters.realState}&name=${this.filters.name}&paymentStatus=${this.filters.paymentStatus}`)

        this.reserves = data.data

        const total = Number(data.total)
        this.total = total

        this.optionsPage.push(total)
        this.optionsPage.sort((a, b) => (a > b) ? 1 : -1)
      } catch (error) {
        message.error('Erro ao buscar reservas')
      } finally {
        this.loading = false
      }
    },

    async getNumberLots () {
      try {
        const response = await api.get('/number-lots')
        this.numberLots = response.data
      } catch (error) {
        message.error('Erro ao buscar número de lotes')
      } finally {
        this.loading = false
      }
    },

    async getSizeLots (propertyId) {
      try {
        const response = await api.get(`/size-lots?propertyId=${propertyId}`)
        this.sizeLots = response.data
      } catch (error) {
        message.error('Erro ao buscar número de lotes')
      } finally {
        this.loading = false
      }
    },

    async getTypeAtendances () {
      try {
        const response = await api.get('/type-atendances')
        this.typeAtendances = response.data
      } catch (error) {
        message.error('Erro ao buscar os tipos de atendimentos')
      } finally {
        this.loading = false
      }
    },

    async getTypeBuys () {
      try {
        const response = await api.get('/type-buys')
        this.typeBuys = response.data
      } catch (error) {
        message.error('Erro ao buscar os tipos de compra')
      } finally {
        this.loading = false
      }
    },

    async getConditionPayments () {
      try {
        const response = await api.get('/condition-payments')
        this.conditionPayments = response.data
      } catch (error) {
        message.error('Erro ao buscar as condições de pagamento')
      } finally {
        this.loading = false
      }
    },

    async getSizeApartments () {
      try {
        const response = await api.get(`/size-apartments`)
        this.sizeApartments = response.data
      } catch (error) {
        message.error('Erro ao buscar tamanhos de apartamentos')
      } finally {
        this.loading = false
      }
    },

    validate () {
      if (this.$refs.form.validate()) {
        this.save()
      }
    },

    async edit (item) {
      if (item.payment_status_id > 2) {
        message.error('A reserva possui solicitação de Abatimento ou Devolução. Contate a Idealiza.')
        return
      }
      this.loadingMessage = 'Carregando'
      this.loading = true

      this.editItemToTable(item)
      this.loading = false
    },

    editItemToTable (item) {
      this.editedIndex = this.reserves.indexOf(item)
      this.editedId = item.id
      this.reserve = Object.assign({}, item)

      this.reserve.documents.forEach(doc => { doc.name = doc.original_name })

      this.reserve.identifierClient = item.client.cnpj ? item.client.cnpj : item.client.cpf
      this.reserve.broker = item.broker
      this.reserve.buildInTwoYears = item.build_in_two_years
      this.reserve.parkingSpace = item.parking_space
      this.actualNumberLot = item.numberLot.id
      this.historyDocs = JSON.parse(JSON.stringify(item.documents))
      this.dialog = true
    },

    async deleteItem () {
      if (this.hasSure) {
        this.loadingMessage = 'Removendo'
        this.loading = true

        try {
          await api.delete(`/reserves/${this.itemToDelete.id}`)
          message.success('Reserva removida')
          this.removeToTable(this.itemToDelete)
        } catch (error) {
          message.error(message.error)
        } finally {
          this.loading = false
        }
      }
    },

    async getBrokers () {
      try {
        const { data } = await api.get('/users?page=-1&itemsPerPage=-1')
        this.brokerItems = data.data
      } catch (error) {
        message.error('Erro ao buscar corretores')
      } finally {
        this.loading = false
      }
    },

    openConfirmModal (item) {
      this.itemToDelete = item
      this.confirmModal = true
    },

    handleCancelConfirmModal () {
      this.hasSure = false
      this.confirmModal = false
    },

    handleAcceptConfirmModal () {
      this.hasSure = true
      this.confirmModal = false
      this.deleteItem()
    },

    removeToTable (item) {
      const index = this.reserves.indexOf(item)
      this.reserves.splice(index, 1)
    },

    close () {
      this.dialog = false

      this.reserve.identifierClient = null
      this.$nextTick(() => {
        this.reserve = Object.assign({}, this.defaultItem)
        this.reserve.broker = store.getters.user.broker
        this.actualNumberLot = null
        this.editedIndex = -1
      })
    },

    filterReserves () {
      this.options.page = 1
      this.getReserves()
    },

    clearFilters () {
      this.filters.typeAtendance = null
      this.filters.status = null
      this.filters.property = null
      this.filters.realState = null
      this.filters.name = null
      this.filters.paymentStatus = null
      this.options.page = 1

      this.getReserves()
    },

    async save () {
      if (!store.getters.config.showMenuReserves) {
        message.error('Ainda não é possível cadastrar reserva')
        return
      }

      this.loading = true

      if (this.editedIndex === -1) {
        this.loadingMessage = 'Salvando'
        let savedDocuments = []

        if (this.reserve.typeAtendance === 1) {
          if (Array.isArray(this.reserve.document)) {
            for (const doc of this.reserve.document) {
              const savedDoc = await this.createDocument(doc)
              if (!savedDoc) return
              savedDocuments = savedDoc
            }
          } else {
            const savedDoc = await this.createDocument(this.reserve.document)
            if (!savedDoc) return
            savedDocuments = savedDoc
          }
          if (!savedDocuments || savedDocuments.length === 0) return
        }

        this.createReserve(savedDocuments)
      } else {
        this.loadingMessage = 'Atualizando'
        let savedDocuments = []

        if (this.reserve.newDocument) {
          if (Array.isArray(this.reserve.newDocument)) {
            for (const doc of this.reserve.newDocument) {
              const savedDoc = await this.createDocument(doc)
              if (!savedDoc) return
              savedDocuments.push(savedDoc)
            }
          } else {
            const savedDoc = await this.createDocument(this.reserve.newDocument)
            if (!savedDoc) return
            savedDocuments.push(savedDoc)
          }
        }

        this.updateReserve(savedDocuments)
      }
    },

    async createDocument (image) {
      try {
        const file = await normalizeFiles(image)
        const formData = new FormData()
        formData.append('images', file)
        formData.append('directory', 'reserves')

        const response = await api.post('documents', formData)
        this.reserve.documents.push(response.data)
        message.success('Documento salvo')
        return response.data
      } catch (error) {
        message.error('Erro ao salvar documento')
        message.error('Reserva não criada')
        return false
      } finally {
        this.loading = false
      }
    },

    async updateDocument (imageFile, id) {
      try {
        const file = await normalizeFiles(imageFile)
        const formData = new FormData()
        formData.append('image', file)
        formData.append('directory', 'reserves')

        const { data } = await api.put(`/documents/${id}`, formData)
        message.success('Documento atualizado')

        await api.put(`reserves/${this.reserve.id}/status`, { status_id: 1 })
        this.reserve.status.id = 1
        return data
      } catch (error) {
        message.error(error.message)
        return false
      } finally {
        this.loading = false
      }
    },

    async getData () {
      const data = {
        id: this.reserve.id,
        property_id: this.reserve.property.id ? this.reserve.property.id : this.reserve.property,
        broker_id: this.reserve.broker.id ? this.reserve.broker.id : this.reserve.broker,
        client_id: this.reserve.client.id ? this.reserve.client.id : this.reserve.client,
        type_atendance_id: this.reserve.typeAtendance.id ? this.reserve.typeAtendance.id : this.reserve.typeAtendance,
        // number_lot_id: this.reserve.numberLot.id ? this.reserve.numberLot.id : this.reserve.numberLot,
        number_lot_id: 1,
        // size_lot_id: this.reserve.sizeLot.id ? this.reserve.sizeLot.id : this.reserve.sizeLot,
        first_lot_id: this.reserve.firstLot ? this.reserve.firstLot.id ? this.reserve.firstLot.id : this.reserve.firstLot : this.reserve.firstLot,
        second_lot_id: this.reserve.secondLot ? this.reserve.secondLot.id ? this.reserve.secondLot.id : this.reserve.secondLot : this.reserve.secondLot,
        third_lot_id: this.reserve.thirdLot ? this.reserve.thirdLot.id ? this.reserve.thirdLot.id : this.reserve.thirdLot : this.reserve.thirdLot,
        fourth_lot_id: this.reserve.fourthLot ? this.reserve.fourthLot.id ? this.reserve.fourthLot.id : this.reserve.fourthLot : this.reserve.fourthLot,
        fifth_lot_id: this.reserve.fifthLot ? this.reserve.fifthLot.id ? this.reserve.fifthLot.id : this.reserve.fifthLot : this.reserve.fifthLot,
        type_buy_id: this.reserve.typeBuy.id ? this.reserve.typeBuy.id : this.reserve.typeBuy,
        condition_payment_id: this.reserve.conditionPayment.id ? this.reserve.conditionPayment.id : this.reserve.conditionPayment,
        status_id: this.reserve.status.id,
        build_in_two_years: this.reserve.buildInTwoYears || false,
        size_apartment_id: this.reserve.sizeApartment ? this.reserve.sizeApartment.id ? this.reserve.sizeApartment.id : this.reserve.sizeApartment : this.reserve.sizeApartment,
        parking_space: this.reserve.parkingSpace || false,
        documents: this.reserve.documents
      }

      data.second_lot_id = data.number_lot_id < 2 ? null : data.second_lot_id
      data.third_lot_id = data.number_lot_id < 3 ? null : data.third_lot_id
      data.fourth_lot_id = data.number_lot_id < 4 ? null : data.fourth_lot_id
      data.fifth_lot_id = data.number_lot_id < 5 ? null : data.fifth_lot_id

      return data
    },

    async createReserve (savedDocuments) {
      try {
        let data = await this.getData()
        data = {
          ...data,
          documents: savedDocuments.length > 0 ? savedDocuments : data.documents
        }
        const response = await api.post('/reserves', data)
        const broker = this.reserve.broker.id ? this.reserve.broker.id : this.reserve.broker
        if (this.brokerLogged.id === broker) {
          this.addToTable(response.data)
          this.total = this.total + 1
        }

        message.success('Reserva salva')
      } catch (error) {
        message.error(error.message)
      } finally {
        this.loading = false
        this.close()
      }
    },

    async updateReserve (savedDocuments) {
      try {
        let data = await this.getData()
        data = {
          ...data,
          documents: savedDocuments.length > 0 ? savedDocuments : data.documents
        }
        const response = await api.put(`/reserves/${this.editedId}`, data)

        const broker = this.reserve.broker.id ? this.reserve.broker.id : this.reserve.broker
        if (broker !== this.reserve.broker_id) {
          this.reserves.splice(this.editedIndex, 1)
        } else {
          this.addToTable(response.data)
        }
        message.success('Reserva atualizada')
      } catch (error) {
        message.error(error.message)
      } finally {
        this.loading = false
        this.close()
      }
    },

    addToTable (item) {
      if (this.editedIndex > -1) {
        Object.assign(this.reserves[this.editedIndex], item)
      } else {
        this.reserves.push(item)
      }
    }
  }
}
</script>

<style scoped>
  .btn-filter {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/reserves/Reserves.vue